import axios from 'axios'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import {
  faCity,
  faFloppyDisk,
  faMap,
  faRedo,
  faSearch,
  faSync,
  faUndo,
} from '@fortawesome/free-solid-svg-icons'
import { DrawingManager, GoogleMap, Polygon, Marker } from '@react-google-maps/api'
import { Form, InputRef } from 'antd'
import { kinks, polygon as turfPolygon } from '@turf/turf'

//STYLE
import { ContainerDesenho, Painel } from './styles'

//APP
import { buscaCidade, calculoAreaCoord, centerMap, listUf, polyGetPath } from '../../../../../services/Afins'
import { destroyAlert, errorAlert, loadingAlert, successAlert } from '../../../../../utils/alert'
import { geralKmlPolygon } from '../../../../../Components/gerarKml'
import { postTalhaoCultivavel, putTalhaoCultivavel } from '../../../../../services/TalhaoSafra'
import { postTalhao, putTalhao } from '../../../../../services/Talhao'
import { Switcher } from '../../../../../Components/CustomUi/Switcher'
import { Render } from '../../../../../Components/CustomUi/render'
import { Select } from '../../../../../Components/CustomUi/Select'
import Input from '../../../../../Components/CustomUi/input'
import ButtonCustom from '../../../../../Components/ButtonCustom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box } from '../../../../../Components/CustomUi/box'
import { TitleH3 } from '../../../../../Components/CustomUi/titleH3'

export interface TypesDesenhoTalhao {
  propriedade: number
  update: number
  visible?: boolean
  onClose?: (data: boolean) => void
  atualizar: (codPro: number, nome: string) => void
  cultivavel: boolean
  dataPolygon?: {
    coordenadas?: google.maps.LatLng[]
    nome?: string
    lookat?: google.maps.LatLng
  }
}

const DesenhaTalhaoNovo: React.FC<TypesDesenhoTalhao> = (props) => {
  const { propriedade, update, atualizar, cultivavel, dataPolygon = { coordenadas: [] } } = props

  const inputRef = useRef<InputRef>(null)

  const [form] = Form.useForm()

  const [getPath, setPath] = useState([])
  const [getAreatalhao, setGetAreatalhao] = useState<number>(0)
  const [getCenter, setCenter] = useState<google.maps.LatLng | google.maps.LatLngLiteral>({
    lat: -18.4590515,
    lng: -64.3517889,
  })
  const [uf, setUf] = useState<string>('')
  const [openUf, setOpenUf] = useState<boolean>(false)
  const [cidade, setCidade] = useState<string>('')
  const [cidadeId, setCidadeId] = useState<number>(null)
  const [openCidade, setOpenCidade] = useState<boolean>(false)
  const [longitude, setLongitude] = useState<string>('')
  const [latitude, setLatitude] = useState<string>('')
  const [nome, setNome] = useState<string>('')
  const [area, setArea] = useState<string>('')
  const [codPropriedade, setCodPropriedade] = useState<number>(0)

  const [coordPoly, setCoordPoly] = useState([])
  const [kinksPoints, setKinksPoints] = useState<{ lat: number, lng: number }[]>([])

  const [getZoom, setZoom] = useState<number>(4)

  const [typeBusca, setTypeBusca] = useState(false)

  const [getlistUf, setListUf] = useState([])

  const [getlistCity, setListCity] = useState([])

  const [undoPolygon, setUndoPolygon] = useState([])
  const [redoPolygon, setRedoPolygon] = useState([])

  const [getLoadingBuscaCoord, setLoadingBuscaCoord] = useState(false)

  const [drawing, setDrawing] = useState<google.maps.drawing.DrawingManager>()
  const [polygon, setPolygon] = useState<google.maps.Polygon>()
  const [map, setMap] = useState<google.maps.Map>()
  const [listener, setListener] = useState(null)
  const [mapKey, setMapKey] = useState(0)

  const polylineRef = useRef(null)

  const mapRef = useRef(null)

  const listenersRef = useRef([])

  const onUnmount = useCallback(() => {
    listenersRef.current.forEach((lis) => lis.remove())
    polylineRef.current = null
  }, [])

  const showPath = () => {
    const path = getPath.filter((data) => {
      return data !== undefined
    })

    const area = window.google.maps.geometry.spherical.computeArea(path)

    const ha = parseFloat((area / 10000).toFixed(2))

    setGetAreatalhao(ha)

    setArea(ha.toFixed(2).toString().replace('.', ','))
  }

  const handleListUf = async () => {
    const response = await listUf()
    setListUf(response)
  }

  const handleUndo = () => {
    const old = [...undoPolygon]

    const index = undoPolygon.length - 1
    let newArray = []
    let newCoord = []
    old.forEach((data, i) => {
      if (data !== undefined) {
        if (index !== i) {
          const info = data
          newArray = [...newArray, info]
        } else {
          setRedoPolygon([...redoPolygon, data])
          newCoord = [old[i - 1]]
        }
      }

      return { newArray, newCoord }
    })

    polygon.setPaths(newCoord)

    setGetAreatalhao(calculoAreaCoord(newCoord))
    setArea(String(calculoAreaCoord(newCoord)))

    setUndoPolygon(newArray)
  }

  const onLoadMap = () => {
    //
  }

  const handleRedo = () => {
    const old = [...redoPolygon]

    const index = redoPolygon.length - 1
    let newArray = []
    let newCoord = []
    old.forEach((data, i) => {
      if (data !== undefined) {
        if (index !== i) {
          const info = data
          newArray = [...newArray, info]
        } else {
          setUndoPolygon([...undoPolygon, data])
          newCoord = [old[i]]
        }
      }

      return { newArray, newCoord }
    })

    polygon.setPaths(newCoord)

    setGetAreatalhao(calculoAreaCoord(newCoord))
    setArea(String(calculoAreaCoord(newCoord)))

    setRedoPolygon(newArray)
  }

  const handleResetDesenho = () => {
    setUndoPolygon([])
    setRedoPolygon([])
    polygon.setPaths([])
    setArea('')
    setNome('')
    setKinksPoints([])
  }

  const validateKinks = (coordinates) => {
    try {
      if (coordinates.length < 4) return [];
      const coords = coordinates.map((c) => [c.lng, c.lat]);
      coords.push(coords[0]);
      const poly = turfPolygon([coords]);
      const intersectKinks = kinks(poly);
      if (intersectKinks.features.length > 0) {
        return intersectKinks.features.map(feature => ({
          lng: feature.geometry.coordinates[0],
          lat: feature.geometry.coordinates[1]
        }));
      }
      return [];
    } catch {
      return [];
    }
  }

  const handlePolylineComplete = (e: google.maps.Polyline) => {
    const dados = polyGetPath(e)

    setCoordPoly(dados)
    setUndoPolygon([dados])
    polygon.setPaths(dados)
    drawing.setDrawingMode(null)
    const ha = calculoAreaCoord([dados])
    setArea(String(ha))
    setGetAreatalhao(ha)

    // e.setPath([])

    const newListener = google.maps.event.addListener(e, 'rightclick', (event) => {
      if (event.vertex !== null && event.vertex !== undefined) {
        e.getPath().removeAt(event.vertex)

        setCoordPoly(e.getPath().getArray())
        setUndoPolygon([e.getPath().getArray()])
        polygon.setPaths(e.getPath().getArray())
        drawing.setDrawingMode(null)
        const nova_ha = calculoAreaCoord([e.getPath().getArray()])
        setArea(String(nova_ha))
        setGetAreatalhao(nova_ha)
        setKinksPoints(validateKinks(e.getPath().getArray()))

        inputRef.current.focus({
          cursor: 'all',
        })
      }
    })

    setListener(newListener)

    // Listener para atualizar `setCoordPoly` ao mover vértices
    const setAtListener = google.maps.event.addListener(e.getPath(), 'set_at', () => {
      setCoordPoly(e.getPath().getArray())
      setUndoPolygon([e.getPath().getArray()])
      polygon.setPaths(e.getPath().getArray())

      // Opcional: Atualizar área ou outros estados relacionados
      const updatedArea = calculoAreaCoord([e.getPath().getArray()])
      setArea(String(updatedArea))
      setGetAreatalhao(updatedArea)
      setKinksPoints(validateKinks(e.getPath().getArray()))
    })
  }

  const handleMouseUpPolygon = () => {
    const dados = polyGetPath(polygon)

    setUndoPolygon([...undoPolygon, dados])
    const ha = calculoAreaCoord([dados])

    setArea(String(ha))
    setGetAreatalhao(ha)
    setKinksPoints(validateKinks(dados))
  }

  const onFinish = async () => {
    try {
      loadingAlert({ msg: 'Aguarde...', id: 'cadastro_talhao' })

      const polygonFinish = polyGetPath(polygon)

      const kml = geralKmlPolygon(polygonFinish, nome)

      const cripto = btoa(kml)

      const arquivo = `data:@file/xml;base64,${cripto}`

      const dados = {
        nome: nome,
        cod_propriedade: propriedade,
        arquivo: arquivo,
        status: 1,
        area: String(area),
      }

      if (update <= 0) {
        const response = cultivavel
          ? await postTalhaoCultivavel(propriedade, dados)
          : await postTalhao(propriedade, dados)
        if (response.status === 201) {
          successAlert('Talhão cadastrado com sucesso!', 5000, 'cadastro_talhao')
          atualizar(propriedade, '')
        }
      } else {
        const response = cultivavel
          ? await putTalhaoCultivavel(propriedade, update, dados)
          : await putTalhao(propriedade, update, dados)
        if (response.status === 200) {
          successAlert('Talhão atualizado com sucesso!', 5000, 'cadastro_talhao')
          atualizar(propriedade, '')
        }
      }
    } catch (error) {
      if (error.response) {
        const { data } = error.response
        if (!data.error[0].field) {
          errorAlert(data?.error ?? 'Falha ao registrar talhão', 5000, 'cadastro_talhao')
        } else {
          data.error.forEach((data) => {
            errorAlert(data?.msg?.[0] ?? 'Falha ao registrar talhão', 5000, 'cadastro_talhao')
          })
        }
      } else {
        destroyAlert()
      }
    }
  }

  const onFinishCoord = () => {
    // data
  }

  const onFildesChangeCoord = () => {
    // data
  }

  const onLoadDrawing = (drawing: google.maps.drawing.DrawingManager) => {
    setDrawing(drawing)
  }

  const handleSelectedUF = async (data) => {
    const response = await buscaCidade('', data, '')
    setListCity(response)
  }

  const handleClickCoord = () => {
    const lat = parseFloat(latitude)

    const lng = parseFloat(longitude)

    setCenter({ lat, lng })
    mapRef.current.state.map.zoom = 15
  }

  const handleClickCity = async () => {
    setLoadingBuscaCoord(true)

    const response = await buscaCidade('', '', cidadeId)

    const resp = response[0]

    const coord = await axios.get(
      `https://maps.googleapis.com/maps/api/geocode/json?address=${resp.nome}+${resp.uf_sigla}&key=${process.env.REACT_APP_TOKEN_GOOGLE_MAPS}`
    )
    // @ts-ignore
    const location = coord.data?.results[0].geometry.location

    const { lat, lng } = location

    setCenter({ lat, lng })
    // mapRef.current.state.map.zoom = 15;
    setZoom(15)

    setLoadingBuscaCoord(false)
  }

  const handleChangeTypeCenter = (data) => {
    setTypeBusca(data)
  }

  // const mapZoom = () => {};

  useEffect(() => {
    const registro = getPath.length - 1

    if (getPath.length > 0 && getPath[registro] !== undefined) {
      showPath()
    }
  }, [getPath])

  useEffect(() => {
    if (propriedade === undefined || propriedade === null) {
      //
    } else {
      form.setFieldsValue({ cod_propriedade: propriedade })
    }
  }, [propriedade])

  useEffect(() => {
    if (dataPolygon.coordenadas.length > 0) {
      const coord = dataPolygon.coordenadas

      setPath(coord)

      setCoordPoly(coord)
      setUndoPolygon([coord])
      const ha = calculoAreaCoord([coord])
      setArea(String(ha))
      setNome(dataPolygon.nome)
      setZoom(12)

      const center = centerMap(coord)

      setCenter(center)
      setKinksPoints(validateKinks(coord))
    }
  }, [dataPolygon])

  useEffect(() => {
    if (drawing) {
      drawing.setDrawingMode(null)
      setCoordPoly([])
      setPath([])
      setArea('')
      setNome('')
      setUf('')
      setCidade('')
      setCidadeId(null)
      setLatitude('')
      setLongitude('')

    }
  }, [atualizar])

  useEffect(() => {
    handleListUf()
  }, [])

  useEffect(() => {
    return () => {
      if (listener) {
        google.maps.event.removeListener(listener)
        setListener(null)
      }
    }
  }, [])
  console.log(getZoom)
  return (
    <ContainerDesenho>
      <GoogleMap
        ref={mapRef}
        onLoad={onLoadMap}
        options={{
          mapTypeId: 'hybrid',
          mapTypeControl: false,
          streetViewControl: false,
        }}
        mapContainerStyle={{
          width: '77%',
          height: '81vh',
        }}
        center={getCenter}
        zoom={getZoom}
      >
        {/* Desenha talhao e movimentar no mapa */}
        <DrawingManager
          onLoad={onLoadDrawing}
          onPolylineComplete={handlePolylineComplete}
          options={{
            polylineOptions: {
              strokeColor: 'cyan',
              strokeWeight: 4,
              clickable: true,
              draggable: false,
              editable: true,
              geodesic: false,
            },
            drawingControl: update <= 0,
            drawingControlOptions: {
              drawingModes: [window.google.maps.drawing.OverlayType.POLYLINE],
            },
          }}
        />

        <Polygon
          onLoad={(data) => setPolygon(data)}
          paths={getPath}
          onMouseUp={handleMouseUpPolygon}
          onUnmount={onUnmount}
          options={{
            fillColor: kinksPoints.length > 0 ? '#ff4d4f' : 'cyan',
            strokeColor: kinksPoints.length > 0 ? '#ff4d4f' : 'cyan',
            strokeWeight: 4,
            fillOpacity: 0.45,
            clickable: true,
            draggable: false,
            editable: false,
            geodesic: false,
          }}
        />

        {kinksPoints.map((point, index) => (
          <Marker
            key={`kink_${index}`}
            position={point}
            title="Vértice sobreposto!"
            icon={{
              path: 'M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z',
              fillColor: '#ff0000',
              fillOpacity: 1,
              strokeColor: '#000',
              strokeWeight: 1,
              scale: 1,
              labelOrigin: new window.google.maps.Point(0, -28)
            }}
            label={{ text: '!', color: 'white', fontWeight: 'semi-bold' }}
          />
        ))}

      </GoogleMap>

      <Painel>
        <Switcher isChecked={typeBusca} trigger={setTypeBusca} label='Busca por Coordenadas' />
        <Render condition={typeBusca === false}>
          <Select
            label='UF'
            icon={faMap}
            placeholder='Selecione a UF'
            value={uf}
            onChange={setUf}
            onChangeID={handleSelectedUF}
            open={openUf}
            trigger={setOpenUf}
            items={getlistUf}
            descricaoItem={'sigla'}
            idItem={'cod'}
          />
          <Select
            label='Cidade'
            icon={faCity}
            placeholder='Selecione a cidade'
            value={cidade}
            onChange={setCidade}
            onChangeID={setCidadeId}
            open={openCidade}
            trigger={setOpenCidade}
            items={getlistCity}
            descricaoItem={'nome'}
            idItem={'cod'}
          />
        </Render>
        <Render condition={typeBusca}>
          <Input
            label='Latitude'
            placeholder='Digite a latitude'
            value={latitude}
            onChange={setLatitude}
          />
          <Input
            label='Longitude'
            placeholder='Digite a longitude'
            value={longitude}
            onChange={setLongitude}
          />
        </Render>
        <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
          <ButtonCustom
            icon={<FontAwesomeIcon icon={faSearch} />}
            onClick={typeBusca ? handleClickCoord : handleClickCity}
          >
            Buscar
          </ButtonCustom>
        </div>
      </Painel>

      <Box style={{ width: '23%', height: '100%' }}>
        <TitleH3>Dados talhão</TitleH3>
        <Input label='Nome' placeholder='Digite o nome do talhão' value={nome} onChange={setNome} />
        <Input
          label='Área(ha)'
          placeholder='Digite a área do talhão'
          value={area}
          onChange={setArea}
        />
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', gap: '5px' }}>
            <ButtonCustom
              disabled={undoPolygon.length <= 1}
              onClick={handleUndo}
              style={{ color: 'white' }}
              title='Desfazer'
              icon={<FontAwesomeIcon icon={faUndo} />}
            />
            <ButtonCustom
              disabled={redoPolygon.length <= 0}
              onClick={handleRedo}
              style={{ color: 'white' }}
              title='Refazer'
              icon={<FontAwesomeIcon icon={faRedo} />}
            />
            <ButtonCustom
              disabled={getPath.length <= 0}
              onClick={handleResetDesenho}
              style={{ color: 'white' }}
              type='primary'
              danger
              title='Resetar'
              icon={<FontAwesomeIcon icon={faSync} />}
            />
          </div>
          {kinksPoints.length > 0 ? (
            <ButtonCustom icon={<FontAwesomeIcon icon={faFloppyDisk} />} type="primary" danger disabled onClick={() => { }}>
              Salvar correção
            </ButtonCustom>
          ) : (
            <ButtonCustom icon={<FontAwesomeIcon icon={faFloppyDisk} />} onClick={onFinish}>
              {update > 0 ? 'Atualizar talhão' : 'Gerar talhão'}
            </ButtonCustom>
          )}
        </div>
      </Box>
    </ContainerDesenho>
  )
}

export default DesenhaTalhaoNovo